import React, { useState, useEffect } from 'react';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../Mensaje';
import Cargando from '../../../../../Cargando';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { FaEdit, FaTrash, FaPlus, FaSync, FaSearch, FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import CryptoJS from 'crypto-js';
import AuthUser from '../../../../../pageauth/AuthUser';

export const RW_Clientes = () => {
    require('../../Remotework.css?v=1.1.0');
    const { ObtenerClientesAdmin, CrearCliente, ActualizarCliente, EliminarCliente, ObtenerEstaciones } = PuenteApi();
    const { StartCargando, StopCargando } = Cargando();
    const { getUser } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [clientesUnificados, setClientesUnificados] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [busqueda, setBusqueda] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const [clienteActual, setClienteActual] = useState({
        id: "",
        cuit: "",
        razon_social: "",
        domicilio: "",
        provincia: "",
        localidad: "",
        cp: "",
        telefono: "",
        celular: "",
        telefono_laboral: "",
        email: "",
        condicion_iva: "Consumidor Final",
        notificaciones: false,
        observaciones: "",
        cuenta_corriente: false,
        exento: false,
        convenio: false,
        iva: false,
        credito_maximo: "0.00",
        saldo_remitos: "0.00",
        credito_disponible: "0.00",
        precio_especial_vencimiento: "",
        listado_precios_asociada: "",
        combustible: false,
        minimercado: false,
        playa: false
    });

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        cargarEstaciones();
    }, []);

    const cargarEstaciones = async () => {
        const estacionesGuardadas = localStorage.getItem("estaciones");
        let listaEstaciones = [];

        if (estacionesGuardadas) {
            try {
                const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
                listaEstaciones = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                setEstaciones(listaEstaciones);
            } catch (error) {
                console.error("Error decrypting stations", error);
            }
        }

        if (listaEstaciones.length === 0) {
            StartCargando("Cargando estaciones...");
            const response = await ObtenerEstaciones();
            StopCargando();
            if (response) {
                setEstaciones(response);
                listaEstaciones = response;
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
            }
        }

        if (listaEstaciones.length > 0) {
            cargarClientesDeTodas(listaEstaciones);
        }
    };

    const cargarClientesDeTodas = async (listaEstaciones) => {
        StartCargando("Cargando clientes de todas las estaciones...");
        let todosLosClientes = [];

        for (const estacion of listaEstaciones) {
            const clientesEstacion = await ObtenerClientesAdmin(estacion.endpoint);
            if (clientesEstacion) {
                const clientesConEstacion = clientesEstacion.map(c => ({ ...c, estacionId: estacion.id, estacionNombre: estacion.nombre }));
                todosLosClientes = [...todosLosClientes, ...clientesConEstacion];
            }
        }
        StopCargando();
        unificarClientes(todosLosClientes, listaEstaciones);
    };

    const unificarClientes = (todosLosClientes, listaEstaciones) => {
        const mapaClientes = {};

        todosLosClientes.forEach(cliente => {
            const uniqueKey = cliente.cuit || cliente.email || cliente.razon_social; // Prefer CUIT
            if (!mapaClientes[uniqueKey]) {
                mapaClientes[uniqueKey] = {
                    ...cliente,
                    estacionesEncontradas: [cliente.estacionId],
                    datosPorEstacion: { [cliente.estacionId]: cliente }
                };
            } else {
                mapaClientes[uniqueKey].estacionesEncontradas.push(cliente.estacionId);
                mapaClientes[uniqueKey].datosPorEstacion[cliente.estacionId] = cliente;
            }
        });

        const clientesFinales = Object.values(mapaClientes).map(cliente => {
            const faltanteEn = listaEstaciones.filter(e => !cliente.estacionesEncontradas.includes(e.id));
            return {
                ...cliente,
                faltanteEn: faltanteEn
            };
        });
        setClientesUnificados(clientesFinales);
    };

    const handleClose = () => {
        setShowModal(false);
        setClienteActual({
            id: "", cuit: "", razon_social: "", domicilio: "", provincia: "", localidad: "", cp: "",
            telefono: "", celular: "", telefono_laboral: "", email: "", condicion_iva: "Consumidor Final",
            notificaciones: false, observaciones: "", cuenta_corriente: false, exento: false, convenio: false, iva: false,
            credito_maximo: "0.00", saldo_remitos: "0.00", credito_disponible: "0.00",
            precio_especial_vencimiento: "", listado_precios_asociada: "",
            combustible: false, minimercado: false, playa: false
        });
        setModoEdicion(false);
    };

    const handleShow = () => setShowModal(true);

    const handleGuardarCliente = async (e) => {
        e.preventDefault();
        StartCargando("Guardando...");

        const localStation = estaciones.find(e => e.local);
        const remoteStations = estaciones.filter(e => !e.local);

        let remoteSuccessCount = 0;
        let remoteErrors = [];

        // 1. Process Remote Stations
        for (const estacion of remoteStations) {
            let success = false;
            if (modoEdicion) {
                const clienteEnEstacion = clienteActual.datosPorEstacion && clienteActual.datosPorEstacion[estacion.id];
                if (clienteEnEstacion) {
                    success = await ActualizarCliente(estacion.endpoint, { ...clienteActual, id: clienteEnEstacion.id });
                }
            } else {
                success = await CrearCliente(estacion.endpoint, clienteActual);
            }

            if (success) {
                remoteSuccessCount++;
            } else {
                remoteErrors.push(estacion.nombre);
            }
        }

        // 2. Check Remote Results and Prompt for Local if needed
        let proceedWithLocal = true;
        if (remoteErrors.length > 0) {
            StopCargando();
            const result = await Swal.fire({
                title: 'Error en estaciones remotas',
                text: `Falló en: ${remoteErrors.join(', ')}. ¿Desea continuar con la estación local?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Cancelar'
            });
            proceedWithLocal = result.isConfirmed;
            if (proceedWithLocal) StartCargando("Guardando en local...");
        }

        // 3. Process Local Station
        let localSuccess = false;
        if (proceedWithLocal && localStation) {
            if (modoEdicion) {
                const clienteEnEstacion = clienteActual.datosPorEstacion && clienteActual.datosPorEstacion[localStation.id];
                if (clienteEnEstacion) {
                    localSuccess = await ActualizarCliente(localStation.endpoint, { ...clienteActual, id: clienteEnEstacion.id });
                }
            } else {
                localSuccess = await CrearCliente(localStation.endpoint, clienteActual);
            }
        }

        StopCargando();

        if (remoteSuccessCount > 0 || localSuccess) {
            Swal.fire('Éxito', `Operación realizada. Remotos: ${remoteSuccessCount}, Local: ${localSuccess ? 'Sí' : 'No'}.`, 'success');
            handleClose();
            cargarClientesDeTodas(estaciones);
        } else if (!proceedWithLocal && remoteErrors.length > 0) {
            // User cancelled
        } else {
            Swal.fire('Error', 'No se pudo guardar en ninguna estación', 'error');
        }
    };

    const handleSincronizar = async (cliente, estacionDestino) => {
        StartCargando(`Sincronizando en ${estacionDestino.nombre}...`);
        const { id, datosPorEstacion, estacionesEncontradas, faltanteEn, ...datosCliente } = cliente;

        const success = await CrearCliente(estacionDestino.endpoint, datosCliente);
        StopCargando();
        if (success) {
            Swal.fire('Sincronizado', 'Cliente creado en ' + estacionDestino.nombre, 'success');
            cargarClientesDeTodas(estaciones);
        }
    };

    const handleEditar = (cliente) => {
        setClienteActual(cliente);
        setModoEdicion(true);
        handleShow();
    };

    const handleEliminar = (cliente) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Se eliminará de TODAS las estaciones donde existe.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");

                const localStation = estaciones.find(e => e.local);
                const remoteStations = estaciones.filter(e => !e.local);

                let remoteSuccessCount = 0;
                let remoteErrors = [];

                // 1. Remote
                for (const estacion of remoteStations) {
                    if (cliente.estacionesEncontradas.includes(estacion.id)) {
                        const clienteEnEstacion = cliente.datosPorEstacion[estacion.id];
                        const success = await EliminarCliente(estacion.endpoint, { id: clienteEnEstacion.id });
                        if (success) remoteSuccessCount++;
                        else remoteErrors.push(estacion.nombre);
                    }
                }

                // 2. Check Remote & Prompt
                let proceedWithLocal = true;
                if (remoteErrors.length > 0) {
                    StopCargando();
                    const result = await Swal.fire({
                        title: 'Error en estaciones remotas',
                        text: `Falló al eliminar en: ${remoteErrors.join(', ')}. ¿Desea continuar con la estación local?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, continuar',
                        cancelButtonText: 'Cancelar'
                    });
                    proceedWithLocal = result.isConfirmed;
                    if (proceedWithLocal) StartCargando("Eliminando en local...");
                }

                // 3. Local
                let localSuccess = false;
                if (proceedWithLocal && localStation && cliente.estacionesEncontradas.includes(localStation.id)) {
                    const clienteEnEstacion = cliente.datosPorEstacion[localStation.id];
                    localSuccess = await EliminarCliente(localStation.endpoint, { id: clienteEnEstacion.id });
                }

                StopCargando();
                if (remoteSuccessCount > 0 || localSuccess) {
                    Swal.fire('Eliminado!', `Cliente eliminado. Remotos: ${remoteSuccessCount}, Local: ${localSuccess ? 'Sí' : 'No'}.`, 'success');
                    cargarClientesDeTodas(estaciones);
                }
            }
        })
    };

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (name) => {
        if (sortConfig.key !== name) {
            return <FaSort className="ms-1 text-muted" size={12} />;
        }
        if (sortConfig.direction === 'ascending') {
            return <FaSortUp className="ms-1" size={12} />;
        }
        return <FaSortDown className="ms-1" size={12} />;
    };

    const clientesFiltrados = React.useMemo(() => {
        let items = [...clientesUnificados];

        // Filter
        if (busqueda) {
            const termino = busqueda.toLowerCase();
            items = items.filter(cliente =>
                cliente.razon_social.toLowerCase().includes(termino) ||
                cliente.cuit.toLowerCase().includes(termino) ||
                cliente.email.toLowerCase().includes(termino)
            );
        }

        // Sort
        if (sortConfig.key) {
            items.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }

        return items;
    }, [clientesUnificados, busqueda, sortConfig]);

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = clientesFiltrados.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(clientesFiltrados.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="container-fluid py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>Gestión de Clientes</h3>
                <Button variant="primary" onClick={handleShow}>
                    <FaPlus /> Agregar Cliente Global
                </Button>
            </div>

            <div className="card shadow-sm p-4">
                <div className="mb-4 d-flex ">
                    <div className="input-group flex-nowrap" style={{ maxWidth: '500px' }}>
                        <Form.Control
                            type="text"
                            placeholder="Buscar por Razón Social, CUIT o Email..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                            className='buscador'
                        />
                    </div>
                </div>

                <Table striped bordered hover responsive>
                    <thead className="bg-light">
                        <tr>
                            <th onClick={() => requestSort('razon_social')} style={{ cursor: 'pointer' }}>
                                Razón Social {getSortIcon('razon_social')}
                            </th>
                            <th onClick={() => requestSort('cuit')} style={{ cursor: 'pointer' }}>
                                CUIT {getSortIcon('cuit')}
                            </th>
                            <th onClick={() => requestSort('email')} style={{ cursor: 'pointer' }}>
                                Email {getSortIcon('email')}
                            </th>
                            <th>Teléfono</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.map(cliente => (
                            <tr key={cliente.cuit || cliente.email}>
                                <td>{cliente.razon_social}</td>
                                <td>{cliente.cuit}</td>
                                <td>{cliente.email}</td>
                                <td>{cliente.telefono}</td>
                                <td>
                                    {cliente.faltanteEn.length > 0 ? (
                                        <div>
                                            <span className="text-warning fw-bold">Falta en:</span>
                                            <ul className="mb-0 ps-3">
                                                {cliente.faltanteEn.map(e => (
                                                    <li key={e.id} className="d-flex justify-content-between align-items-center">
                                                        <small>{e.nombre}</small>
                                                        <Button variant="outline-success" size="sm" className="py-0 px-1 ms-1" onClick={() => handleSincronizar(cliente, e)} title="Sincronizar">
                                                            <FaSync size={10} />
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ) : (
                                        <span className="text-success">Sincronizado en todas</span>
                                    )}
                                </td>
                                <td>
                                    <Button variant="warning" size="sm" className="me-1" onClick={() => handleEditar(cliente)} title="Editar Globalmente">
                                        <FaEdit />
                                    </Button>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => handleEliminar(cliente)}
                                        title="Eliminar Globalmente"
                                    >
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-3">
                        <Pagination>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                            {[...Array(totalPages)].map((_, index) => (
                                <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
                                    {index + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>
                    </div>
                )}
            </div>

            {/* Modal Cliente */}
            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{modoEdicion ? 'Editar Cliente' : 'Nuevo Cliente'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleGuardarCliente}>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Razón Social</Form.Label>
                                    <Form.Control type="text" value={clienteActual.razon_social} onChange={(e) => setClienteActual({ ...clienteActual, razon_social: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>CUIT</Form.Label>
                                    <Form.Control type="text" value={clienteActual.cuit} onChange={(e) => setClienteActual({ ...clienteActual, cuit: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Condición IVA</Form.Label>
                                    <Form.Select value={clienteActual.condicion_iva} onChange={(e) => setClienteActual({ ...clienteActual, condicion_iva: e.target.value })}>
                                        <option value="Responsable Inscripto">Responsable Inscripto</option>
                                        <option value="Monotributista">Monotributista</option>
                                        <option value="Consumidor Final">Consumidor Final</option>
                                        <option value="Exento">Exento</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" value={clienteActual.email} onChange={(e) => setClienteActual({ ...clienteActual, email: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control type="text" value={clienteActual.telefono} onChange={(e) => setClienteActual({ ...clienteActual, telefono: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Domicilio</Form.Label>
                                    <Form.Control type="text" value={clienteActual.domicilio} onChange={(e) => setClienteActual({ ...clienteActual, domicilio: e.target.value })} required />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Localidad</Form.Label>
                                    <Form.Control type="text" value={clienteActual.localidad} onChange={(e) => setClienteActual({ ...clienteActual, localidad: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Provincia</Form.Label>
                                    <Form.Control type="text" value={clienteActual.provincia} onChange={(e) => setClienteActual({ ...clienteActual, provincia: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Código Postal</Form.Label>
                                    <Form.Control type="text" value={clienteActual.cp} onChange={(e) => setClienteActual({ ...clienteActual, cp: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Crédito Máximo</Form.Label>
                                    <Form.Control type="number" value={clienteActual.credito_maximo} onChange={(e) => setClienteActual({ ...clienteActual, credito_maximo: e.target.value })} />
                                </Form.Group>
                                <Form.Check
                                    type="switch"
                                    id="cuenta-corriente"
                                    label="Habilitar Cuenta Corriente"
                                    checked={clienteActual.cuenta_corriente}
                                    onChange={(e) => setClienteActual({ ...clienteActual, cuenta_corriente: e.target.checked })}
                                    className="mb-2"
                                />
                            </div>
                        </div>
                        <Button variant="primary" type="submit">
                            Guardar en Todas las Estaciones
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};
